const isStrEmpty = function (value: any) {
  const valueStr = String(value);
  return valueStr === 'null' || valueStr === 'undefined' || valueStr.length === 0
};

const validPhone = (value: any, countryCode: any) => {
  if (isStrEmpty(value)) {
      return false;
  }
  const phone_array = value.split(",");
  const reg = /^[a-zA-z\u4E00-\u9FA5^`~!@#$%^&*()+=|\\\][\]\{\}:;'\,.<>/?]*$/;
  const reg_letter = /[a-zA-z]+/;
  const digit = /^\d{1,}[\-]*[\.]*\d{1,}[\-]*[\.]*\d+$/;
  const number = /^[0-9]*$/;
  for (let k = 0; k < phone_array.length; k++) {
      const phone_num = phone_array[k];
      if (reg.test(phone_num)) {
          return false;
      }
      if (!number.test(phone_num)) {
          return false;
      }
      if (reg_letter.test(phone_num)) {
          return false;
      }
      if (!digit.test(phone_num)) {
          return false;
      }
      if (phone_num.length < 7 || phone_num.length > 11) {
          return false;
      }
      if (countryCode === '+1' && String(phone_num).length !== 10) {
          return false;
      }
  }
  return true;
};

export default validPhone;